<template>
    <div class="mendian">
        <div style="margin-bottom: 10px;font-weight: 600">
            <span v-for="(item,index) in xiadanList" :style="Curindex === index?{color:'white',backgroundColor:'#f55c00',border:0}:''" class="select-tarbar" @click="selectType(item.value,index)">{{item.value}}</span>
        </div>
        <div class="form" v-show="xiadanType === '门店录单'">
            <h1>门店录单</h1>
            <el-form :label-position="labelPosition" style="text-align: left" :inline="true" label-width="120px" :model="Form">
                <el-form-item label="合同订单号">
                    <el-input v-model="Form.contart_number"></el-input>
                </el-form-item>
                <el-form-item label="客户">
                    <el-input v-model="Form.kehu_name"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="Form.mobile"></el-input>
                </el-form-item>
                <el-form-item label="业务员">
                    <el-autocomplete
                        class="inline-input"
                        @change="getStaffList"
                        v-model="Form.user_name"
                        :fetch-suggestions="querySearch"
                        placeholder="请输入业务员"
                        @select="handleSelect"
                    ></el-autocomplete>
                </el-form-item>
                <el-form-item label="销售门店">
                    <el-autocomplete
                        class="inline-input"
                        v-model="Form.store_name"
                        :fetch-suggestions="querySearch1"
                        placeholder="请输入门店"
                        @select="handleSelect1"
                    ></el-autocomplete>
                    <el-button @click="addMendian">添加</el-button>
                </el-form-item>
                <el-form-item label="经销商">
                    <el-autocomplete
                        class="inline-input"
                        v-model="Form.jingxiao"
                        :fetch-suggestions="querySearch3"
                        placeholder="请输入经销商"
                        @select="handleSelect3"
                    ></el-autocomplete>
                </el-form-item>
                <el-form-item label="预约日期">
                    <el-date-picker
                        v-model="Form.yuyue_time"
                        @change="consl"
                        type="date"
                        placeholder="选择时间"
                        :picker-options="pickerOptions0"></el-date-picker>
                </el-form-item>
                <el-form-item label="销售日期">
                    <el-date-picker
                        v-model="Form.addtime"
                        @change="consl"
                        type="date"
                        placeholder="选择时间"
                        :picker-options="pickerOptions0"></el-date-picker>
                </el-form-item>
            </el-form>
            <el-form :label-position="labelPosition"label-width="120px" :model="Form">
                <el-form-item label="地址">
                    <el-input v-model="Form.address"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="Form.beizhu"></el-input>
                </el-form-item>
            </el-form>
            <el-table :data="goodsList" align="center" empty-text="未添加商品" v-show="goodsList.length !== 0">
                <el-table-column prop="goods_attr" label="型号" align="center"></el-table-column>
                <el-table-column prop="goods_number" label="数量" align="center"></el-table-column>
                <el-table-column prop="goods_price" label="单价" align="center"></el-table-column>
                <el-table-column  label="金额" align="center">
                    <template slot-scope="props">{{props.row.goods_number*props.row.goods_price}}</template>
                </el-table-column>
                <el-table-column  label="操作" align="center">
                    <template slot-scope="props">
                        <!--<el-button type="text" @click="editRow(props.$index, props.row)">修改</el-button><span> | </span>-->
                        <el-button type="text" @click="deleteRow(props.$index, goodsList)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <button class="add-btn"  @click="AddGood">添加商品</button>
            <div style="text-align: center">
                <el-upload
                    style="width:30%;display: inline-block"
                    class="upload-demo"
                    ref="upload"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove='removepz1'
                    :http-request='upImgs1'
                    :on-exceed="handleExceed1"
                    :before-upload="beforeAvatarUpload1"
                    list-type="picture">
                    <button  class="add-btn" style="background-color:#f55c00;">上传附件</button>
                </el-upload>
            </div>
            <button class="add-btn" style="background-color:#d20000;width: 30%;" @click="passOrder">提交订单</button>
        </div>
        <div class="form" v-show="xiadanType === '供应链录单'">
            <h1>供应链录单</h1>
            <el-form :label-position="labelPosition" style="text-align: left" :inline="true" label-width="100px" :model="Form">
                <el-form-item label="合同订单号">
                    <el-input v-model="gylForm.contart_number" placeholder="不录入则自动生成"></el-input>
                </el-form-item>
                <el-form-item label="业务员">
                    <el-autocomplete
                        class="inline-input"
                        v-model="gylForm.yewu_name"
                        :fetch-suggestions="querySearchgy1"
                        placeholder="请输入业务员"
                        @select="handleSelectgy1"
                    ></el-autocomplete>
                </el-form-item>
                <el-form-item label="经销商">
                    <el-autocomplete
                        class="inline-input"
                        v-model="gylForm.jingxiao"
                        :fetch-suggestions="querySearchgy2"
                        placeholder="请输入经销商"
                        @select="handleSelectgy2"
                    ></el-autocomplete><el-button @click="addStaff">添加</el-button>
                </el-form-item>
                <el-form-item label="收货人">
                    <el-input v-model="gylForm.kehu_name"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="gylForm.mobile"></el-input>
                </el-form-item>
                <el-form-item label="销售日期">
                    <el-date-picker
                        v-model="Form.addtime"
                        @change="consl"
                        type="date"
                        placeholder="选择时间"
                        :picker-options="pickerOptions0"></el-date-picker>
                </el-form-item>
            </el-form>
            <el-form :label-position="labelPosition"label-width="120px" :model="Form">
                <el-form-item label="地址">
                    <el-input v-model="gylForm.address"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="gylForm.beizhu"></el-input>
                </el-form-item>
            </el-form>
            <el-form :label-position="labelPosition" style="text-align: left;margin-top: 20px" :inline="true" label-width="120px" :model="Form">
                <el-form-item label="区域">
                    <el-input v-model="gylForm.quyu"></el-input>
                </el-form-item>
                <el-form-item label="仓库">
                    <!--<el-input v-model="gylForm.cangku"></el-input>-->
                    <el-select v-model="gylForm.cangku">
                        <el-option v-for="item in cangkuList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="制单人">
                    <el-input v-model="gylForm.zhidanren"></el-input>
                </el-form-item>
                <el-form-item label="客户">
                    <el-input v-model="Form.inv_payee"></el-input>
                </el-form-item>
            </el-form>
            <el-table :data="goodsList" align="center" empty-text="未添加商品" v-show="goodsList.length !== 0">
                <el-table-column prop="goods_attr" label="型号" align="center"></el-table-column>
                <el-table-column prop="goods_number" label="数量" align="center"></el-table-column>
                <el-table-column prop="goods_price" label="单价" align="center"></el-table-column>
                <el-table-column  label="金额" align="center">
                    <template slot-scope="props">{{props.row.goods_number*props.row.goods_price}}</template>
                </el-table-column>
                <el-table-column  label="操作" align="center">
                    <template slot-scope="props">
                        <!--<el-button type="text" @click="editRow(props.$index, props.row)">修改</el-button><span> | </span>-->
                        <el-button type="text" @click="deleteRow(props.$index, goodsList)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <button class="add-btn"  @click="AddGoods">添加商品</button>
            <div style="text-align: center">
                <el-upload
                    style="width:30%;display: inline-block"
                    class="upload-demo"
                    ref="upload"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove='removepz1'
                    :http-request='upImgs1'
                    :on-exceed="handleExceed1"
                    :before-upload="beforeAvatarUpload1"
                    list-type="picture">
                    <button  class="add-btn" style="background-color:#f55c00;">上传附件</button>
                </el-upload>
            </div>
            <button  class="add-btn" style="background-color:#d20000;width: 30%;" @click="passOrder1">提交订单</button>
        </div>
        <div class="form" v-show="xiadanType === '活动录单'&&isvip==='1'">
            <h1>活动录单</h1>
            <el-form :label-position="labelPosition" style="text-align: left" :inline="true" label-width="100px" :model="Form">
                <el-form-item label="合同订单号">
                    <el-input v-model="gylForm.contart_number" placeholder="不录入则自动生成"></el-input>
                </el-form-item>
                <el-form-item label="VIP卡号">
                    <el-input v-model="gylForm.vip_number" placeholder="请输入VIP卡号"></el-input>
                </el-form-item>
                <el-form-item label="业务员">
                    <el-autocomplete
                        disabled
                        class="inline-input"
                        v-model="gylForm.yewu_name"
                        :fetch-suggestions="querySearchgy1"
                        placeholder="请输入业务员"
                        @select="handleSelectgy1"
                    ></el-autocomplete>
                </el-form-item>
                <el-form-item label="经销商">
                    <el-autocomplete
                        class="inline-input"
                        disabled
                        v-model="gylForm.jingxiao"
                        :fetch-suggestions="querySearchgy2"
                        placeholder="请输入经销商"
                        @select="handleSelectgy2"
                    ></el-autocomplete>
                    <!--<el-button @click="addStaff">添加</el-button>-->
                </el-form-item>
                <el-form-item label="收货人">
                    <el-input v-model="gylForm.kehu_name"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="gylForm.mobile"></el-input>
                </el-form-item>
                <el-form-item label="销售日期">
                    <el-date-picker
                        v-model="Form.addtime"
                        @change="consl"
                        type="date"
                        placeholder="选择时间"
                        :picker-options="pickerOptions0"></el-date-picker>
                </el-form-item>
            </el-form>
            <el-form :label-position="labelPosition"label-width="120px" :model="Form">
                <el-form-item label="地址">
                    <el-input v-model="gylForm.address"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="gylForm.beizhu"></el-input>
                </el-form-item>
            </el-form>
            <el-form :label-position="labelPosition" style="text-align: left;margin-top: 20px" :inline="true" label-width="120px" :model="Form">
                <el-form-item label="区域">
                    <el-input v-model="gylForm.quyu"></el-input>
                </el-form-item>
                <el-form-item label="仓库">
                    <!--<el-input v-model="gylForm.cangku"></el-input>-->
                    <el-select v-model="gylForm.cangku">
                        <el-option v-for="item in cangkuList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="制单人">
                    <el-input v-model="gylForm.zhidanren"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <!--<el-radio v-show="gylForm.inv_type!==''" v-model="gylForm.inv_type" label="">无</el-radio>-->
                    <el-radio v-model="gylForm.inv_type" label="送货到客户">普</el-radio>
                    <el-radio v-model="gylForm.inv_type" label="送货到公司">专</el-radio>
                    <!--<el-radio v-model="form.inv_type" label="">无</el-radio>-->
                    <el-input placeholder="请填写" v-model="gylForm.inv_payee" v-if="gylForm.inv_type!==''" style="width: 200px"></el-input>
                </el-form-item>
            </el-form>
            <el-table :data="goodsList" align="center" empty-text="未添加商品" v-show="goodsList.length !== 0">
                <el-table-column prop="goods_attr" label="型号" align="center"></el-table-column>
                <el-table-column prop="goods_number" label="数量" align="center"></el-table-column>
                <el-table-column prop="goods_price" label="单价" align="center"></el-table-column>
                <el-table-column  label="金额" align="center">
                    <template slot-scope="props">{{props.row.goods_number*props.row.goods_price}}</template>
                </el-table-column>
                <el-table-column  label="操作" align="center">
                    <template slot-scope="props">
                        <!--<el-button type="text" @click="editRow(props.$index, props.row)">修改</el-button><span> | </span>-->
                        <el-button type="text" @click="deleteRow(props.$index, goodsList)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <button class="add-btn"  @click="AddGoods">添加商品</button>
            <div style="text-align: center">
                <el-upload
                    style="width:30%;display: inline-block"
                    class="upload-demo"
                    ref="upload"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove='removepz1'
                    :http-request='upImgs1'
                    :on-exceed="handleExceed1"
                    :before-upload="beforeAvatarUpload1"
                    list-type="picture">
                    <button  class="add-btn" style="background-color:#f55c00;">上传附件</button>
                </el-upload>
            </div>
            <button  class="add-btn" style="background-color:#d20000;width: 30%;" @click="passOrder2">提交订单</button>
        </div>
        <el-dialog title="添加商品" :visible.sync="showAddGoods">
            <el-form :model="addForm" style="width: 80%">
                <el-form-item label="型号" :label-width="formLabelWidth">
                    <el-autocomplete
                        style="width: 100%"
                        class="inline-input"
                        @change="getShopAttr"
                        v-model="addForm.goods_attr"
                        popper-append-to-body="true"
                        :fetch-suggestions="querySearch2"
                        placeholder="请输入型号"
                        @select="handleSelect2"
                    ></el-autocomplete>
                </el-form-item>
                <el-form-item label="数量" :label-width="formLabelWidth">
                    <el-input v-model="addForm.goods_number" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="价格" :label-width="formLabelWidth">
                    <el-input v-model="addForm.goods_price" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showAddGoods = false">取 消</el-button>
                <el-button type="primary" @click="qrAdd">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑商品" :visible.sync="showEditGoods">
            <el-form :model="editForm" style="width: 80%">
                <el-form-item label="型号" :label-width="formLabelWidth">
                    <el-autocomplete
                    style="width: 100%"
                    class="inline-input"
                    @change="getShopAttr"
                    v-model="editForm.goods_attr"
                    :fetch-suggestions="querySearch2"
                    placeholder="请输入型号"
                    @select="handleSelect2"
                ></el-autocomplete>
                    <!--<el-input v-model="editForm.goods_attr" auto-complete="off" ></el-input>-->
                </el-form-item>
                <el-form-item label="数量" :label-width="formLabelWidth">
                    <el-input v-model="editForm.goods_number" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="价格" :label-width="formLabelWidth">
                    <el-input v-model="editForm.goods_price" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showEditGoods = false">取 消</el-button>
                <el-button type="primary" @click="qrEdit">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加经销商" :visible.sync="showYewu">
            <el-form :model="addJxForm" style="width: 80%">
                <el-form-item label="经销商名字" :label-width="formLabelWidth">
                    <el-input v-model="addJxForm.user_name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="经销商代码" :label-width="formLabelWidth">
                    <el-input v-model="addJxForm.user_code" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="结算代码" :label-width="formLabelWidth">
                    <el-input v-model="addJxForm.user_jiesuancode" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="区域" :label-width="formLabelWidth">
                    <el-input v-model="addJxForm.user_area" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="简称" :label-width="formLabelWidth">
                    <el-input v-model="addJxForm.user_address" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="业务员" :label-width="formLabelWidth">
                    <el-input v-model="addJxForm.clerk" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="公司电话" :label-width="formLabelWidth">
                    <el-input v-model="addJxForm.office_phone" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="收货地址" :label-width="formLabelWidth">
                    <el-input v-model="addJxForm.address" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系人" :label-width="formLabelWidth">
                    <el-input v-model="addJxForm.contact" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showYewu = false">取 消</el-button>
                <el-button type="primary" @click="qrAddYewu">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加门店" :visible.sync="showMendian">
            <el-form :model="addMdForm" style="width: 80%">
                <el-form-item label="门店名称" :label-width="formLabelWidth">
                    <el-input v-model="addMdForm.store_name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="门店编号" :label-width="formLabelWidth">
                    <el-input v-model="addMdForm.store_sn" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="区域" :label-width="formLabelWidth">
                    <el-input v-model="addMdForm.store_district" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="业务员" :label-width="formLabelWidth">
                    <el-input v-model="addMdForm.clerk" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="系统" :label-width="formLabelWidth">
                    <el-input v-model="addMdForm.store_system" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="结算公司" :label-width="formLabelWidth">
                    <el-input v-model="addMdForm.account_company" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="仓库" :label-width="formLabelWidth">
                    <el-input v-model="addMdForm.storage" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showMendian = false">取 消</el-button>
                <el-button type="primary" @click="qrAddMendian">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import qs from 'qs'
    import {host} from "../stores/api";

    export default {
            data() {
                return {
                    showAddGoods: false,
                    showEditGoods: false,
                    showYewu: false,
                    showMendian: false,
                    labelPosition: 'right',
                    formLabelWidth: '100px',
                    xiadanType: '门店录单',
                    Curindex: 0,
                    host:host,
                    xiadanList: [{label: '门店录单', value: '门店录单'}, {label: '供应链录单', value: '供应链录单'}],
                    baseImg1: '',
                    addMdForm: {
                        store_name: '',
                        store_sn: '',
                        store_district: '',
                        store_system: '',
                        account_company: '',
                        storage: '',
                        staff_id: '',
                    },
                    addJxForm: {
                        user_name: '',
                        user_code: '',
                        user_jiesuancode: '',
                        user_area: '',
                        user_address: '',
                        clerk: '',
                        office_phone: '',
                        address: '',
                        contact: '',
                    },
                    Form: {
                        contart_number: '',
                        yuyue_time: '',
                        addtime: new Date(),
                        user_name: localStorage.getItem('user_name'),
                        store_name: '',
                        jingxiao: '',
                        jingxiao_id: '',
                        name: '',
                        kehu_name: '',
                        mobile: '',
                        address: '',
                        beizhu: '',
                        goods: [],
                        formData1: [],
                    },
                    cangkuList: [{label: '正价仓', value: '正价仓'}, {label: '不良品仓', value: '不良品仓'}, {label: '天猫仓', value: '天猫仓'}, {label: '赠品仓', value: '赠品仓'},
                        {label: '寄存仓', value: '寄存仓'}, {label: '大金员工仓', value: '大金员工仓'}, {label: '样机展机仓', value: '样机展机仓'}, {label: '直调仓', value: '直调仓'},
                        {label: '物料仓', value: '物料仓'}, {label: '拆旧仓', value: '拆旧仓'}, {label: '待处理仓', value: '待处理仓'}, {label: '公司仓', value: '公司仓'},
                        {label: '苏宁仓', value: '苏宁仓'}, {label: '肇庆苏宁仓', value: '肇庆苏宁仓'}, {label: '家用机赠品仓', value: '家用机赠品仓'}, {label: '春色满园代管仓', value: '春色满园代管仓'},],
                    gylForm: {
                        inv_type: '',
                        inv_payee: '',
                        vip_number: '',
                        contart_number: '',
                        kehu_name: '',
                        mobile: '',
                        address: '',
                        beizhu: '',
                        yewu_name: '',
                        yewu_id: '',
                        jingxiao: '',
                        jingxiao_id: '',
                        quyu: '',
                        cangku: '正价仓',
                        zhidanren: localStorage.getItem('user_name'),
                        user_name: '',
                    },
                    addForm: {
                        goods_attr: '',
                        goods_number: '',
                        goods_price: '',
                        goods_id: '',
                        goods_attr_id: '',
                    },
                    goodsList: [],
                    editForm:{},
                    editIndex: '',
                    restaurants: [],
                    restaurant: [],
                    restaurant1: [],
                    restaurant2: [],
                    restaurantgy1: [],
                    restaurantgy2: [],
                    staff_sn: '',
                    staff_name: '',
                    staff_id: '',
                    isvip: '',
                };
            },
            staff_name() {
                if (this.staff_name !== '') {
                    this.getStaffList()
                }
            },
            created() {
                console.log(this.gylForm.inv_type);
                this.getStaffList()
                this.getStaffListgy1()
            },
            watch: {
                'addForm.goods_attr'() {
                    if (this.addForm.goods_attr === '') {
                        return false
                    } else {
                        this.getShopAttr()
                    }
                },
                'editForm.goods_attr'() {
                    this.getShopAttr()
                },
                'gylForm.vip_number'() {
                    this.getVIP()
                }
            },
            methods: {
                //输入vip获取经销商名字
                getVIP() {
                    this.$http.get(this.$reqUrl + `supply.php?step=vip_get_agency&single_number=${this.gylForm.vip_number}`).then(res => {
                        this.gylForm.yewu_name = res.data.admin_user
                        this.gylForm.jingxiao = res.data.user_name
                        this.gylForm.jingxiao_id = res.data.user_id
                        this.gylForm.kehu_name = res.data.contact
                        this.gylForm.mobile = res.data.office_phone
                        this.gylForm.quyu = res.data.user_area
                        this.gylForm.address = res.data.address
                    })
                },
                //选择录单类型
                selectType(value, index) {
                    this.xiadanType = value
                    this.Curindex = index
                    this.goodsList = []
                    this.Form = {
                        contart_number: '',
                        yuyue_time: '',
                        addtime: new Date(),
                        kehu_name: '',
                        mobile: '',
                        address: '',
                        beizhu: '',
                        goods: [],
                        formData1: [],
                    }
                    this.gylForm = {
                        inv_type: '',
                        inv_payee: '',
                        vip_number: '',
                        contart_number: '',
                        kehu_name: '',
                        mobile: '',
                        address: '',
                        beizhu: '',
                        yewu_name: '',
                        yewu_id: '',
                        jingxiao: '',
                        jingxiao_id: '',
                        quyu: '',
                        cangku: '正价仓',
                        zhidanren: localStorage.getItem('user_name'),
                        user_name: '',
                    }
                },
                AddGood() {
                    this.addForm = {
                        goods_attr: '',
                        goods_number: '',
                        goods_price: '',
                        goods_id: '',
                        goods_attr_id: '',
                    }
                    this.showAddGoods = true
                },
                //添加商品
                AddGoods() {
                    this.addForm = {
                        goods_attr: '',
                            goods_number: '',
                            goods_price: '',
                            goods_id: '',
                            goods_attr_id: '',
                    }
                  if (this.gylForm.jingxiao_id === '') {
                      this.$message.error('请选择经销商')
                  } else {
                      this.showAddGoods = true
                  }
                },
                qrAddYewu() {
                      let data = {
                          staff_name: this.gylForm.yewu_name,
                          ...this.addJxForm
                      }
                      this.$http.post(this.$reqUrl + `user.php?act=users_add&session_id=${localStorage.getItem('shouhou_session_id')}`, qs.stringify(data)).then(res => {
                          if (res.data.error === 0) {
                              this.$message.success('添加成功')
                              this.getStaffListgy1()
                              this.showYewu = false
                              this.addJxForm = {
                                  user_name: '',
                                  user_code: '',
                                  user_jiesuancode: '',
                                  user_area: '',
                                  user_address: '',
                                  clerk: '',
                                  office_phone: '',
                                  address: '',
                                  contact: '',
                              }
                          } else if (res.data.error === 1) {
                              this.$message.error(res.data.msg)
                          }
                      })
                },
                //确认添加商品
                qrAdd () {
                    if (this.addForm.goods_id === '' && this.addForm.goods_attr_id === '') {
                        this.$message.error('商品必须为选择')
                    } else {
                        this.goodsList.push({goods_attr: this.addForm.goods_attr, goods_number: this.addForm.goods_number, goods_price: this.addForm.goods_price, goods_id: this.addForm.goods_id, goods_attr_id: this.addForm.goods_attr_id})
                        this.$message.success('添加成功')
                        // this.addForm = {goods_attr: '', goods_number: '', goods_price: '', goods_id: '',goods_attr_id: ''}
                        this.showAddGoods = false
                    }
                },
                //删除商品
                deleteRow(index, rows) {
                    this.$confirm('确认移除该商品?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).then(() => {
                        rows.splice(index, 1);
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    })
                },
                //编辑商品
                editRow(index, row) {
                    console.log(row);
                    this.showEditGoods = true
                    this.editIndex = index
                    this.editForm = row
                },
                //确认编辑
                qrEdit() {
                    this.goodsList.splice(this.editIndex, 1, this.editForm)
                    this.$message.success('编辑成功')
                    this.showEditGoods = false
                },
                //获取商品型号
                getShopAttr () {
                    this.$http.get(this.$reqUrl + `supply.php?step=goods_model&model=${this.addForm.goods_attr}`).then(res => {
                        this.restaurant1 = []
                        if (res.data.length !== 0) {
                            res.data.forEach((item, index) => {
                                this.restaurant1.push({value: item.attr_value, goods_id: item.goods_id, goods_attr_id:item.goods_attr_id})
                            })
                        }
                        console.log(this.restaurant1.length)
                    })
                },
                //选择型号
                querySearch2(queryString, cb) {
                    var restaurant1 = this.restaurant1;
                    var results = queryString ? restaurant1.filter(this.createFilter2(queryString)) : restaurant1;
                    // 调用 callback 返回建议列表的数据
                    cb(results);
                },
                createFilter2(queryString) {
                    return (restaurant) => {
                        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                    };
                },
                handleSelect2(item) {
                    this.addForm.goods_attr = item.value
                    this.addForm.goods_id = item.goods_id
                    this.addForm.goods_attr_id = item.goods_attr_id
                    var url = this.xiadanType === '活动录单' ? 'goods.php?type=huodong&' : 'goods.php?'
                    this.$http.get(this.$reqUrl + url + `session_id=${localStorage.getItem('shouhou_session_id')}&act=price&number=1&id=${item.goods_id}&attr=${item.goods_attr_id}&user_id=${this.gylForm.jingxiao_id}`).then(res => {
                        this.addForm.goods_attr_id = res.data.goods_attr_id
                        console.log(res.data.goods_attr_id);
                        if (this.xiadanType === '供应链录单' || this.xiadanType === '活动录单') {
                            this.addForm.goods_price = res.data.result_no
                            this.editForm.goods_price = res.data.result_no
                        }
                    })
                },
                //获取业务员列表
                getStaffList() {
                    this.$http.get(this.$reqUrl + `user.php?act=sale_search&name=${this.staff_name}`).then(res => {this.cangkuList = res.data.storage
                        this.restaurants = []
                        if (res.data.data.length !== 0) {
                            res.data.data.forEach((item, index) => {
                                this.restaurants.push({value: item.staff_name, staff_id: item.staff_id, staff_sn: item.staff_sn, users: item.users})
                                if (item.staff_name === this.Form.user_name) {
                                    this.staff_id = item.staff_id
                                    if (item.users) {
                                        item.users.forEach(item => {
                                            this.restaurant2.push({value: item.user_name, user_id: item.user_id})
                                        })
                                        this.Form.jingxiao = item.users[0].user_name
                                        this.Form.jingxiao_id = item.users[0].user_id
                                    }
                                    this.getMendianList()
                                }
                            })
                        }
                    })
                },
                //获取门店列表
                getMendianList () {
                    this.$http.get(this.$reqUrl + `user.php?act=sale_search_store&staff_id=${this.staff_id}`).then(res=>{
                        this.restaurant = []
                        if (res.data.data.length !== 0) {
                            res.data.data.forEach((item, index) => {
                                this.restaurant.push({value: item.store_name, store_sn: item.store_sn})
                            })
                            this.Form.store_name = this.restaurant[0].value
                        } else {
                            this.restaurant = []
                        }
                    })
                },
                //选择业务员
                querySearch(queryString, cb) {
                    var restaurants = this.restaurants;
                    var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                    // 调用 callback 返回建议列表的数据
                    cb(results);
                },
                createFilter(queryString) {
                    return (restaurant) => {
                        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                    };
                },
                querySearch1(queryString, cb) {
                    var restaurant = this.restaurant;
                    var results = queryString ? restaurant.filter(this.createFilter1(queryString)) : restaurant;
                    // 调用 callback 返回建议列表的数据
                    cb(results);
                },
                createFilter1(queryString) {
                    return (restaurant) => {
                        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                    };
                },
                handleSelect(item) {
                    this.staff_id = item.staff_id
                    this.staff_sn = item.staff_sn
                    this.restaurant2 = []
                    this.Form.jingxiao = ''
                    this.Form.jingxiao_id = ''
                    if (item.users) {
                        item.users.forEach(item => {
                            this.restaurant2.push({value: item.user_name, user_id: item.user_id})
                        })
                        this.Form.jingxiao = item.users[0].user_name
                        this.Form.jingxiao_id = item.users[0].user_id
                    }
                    this.Form.store_name = ''
                    this.getMendianList()
                },
                handleSelect1(item) {
                    this.store_sn = item.store_sn
                    this.Form.store_name = item.value
                },
                //选择经销商
                querySearch3(queryString, cb) {
                    var restaurant2 = this.restaurant2;
                    var results = queryString ? restaurant2.filter(this.createFilter3(queryString)) : restaurant2;
                    // 调用 callback 返回建议列表的数据
                    cb(results);
                },
                createFilter3(queryString) {
                    return (restaurant) => {
                        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                    };
                },
                handleSelect3(item) {
                    this.Form.jingxiao = item.value
                    this.Form.jingxiao_id = item.user_id
                },

                //供应链下单
                getStaffListgy1 () {
                    this.$http.get(this.$reqUrl + `supply.php?step=admin_saler`).then(res => {
                        if (res.data.vipstatus === '1') {
                            this.xiadanList.push({label: '活动录单', value: '活动录单'})
                        }
                        this.isvip = res.data.vipstatus
                        this.restaurantgy1=[]
                        if (res.data.data.length !== 0){
                            res.data.data.forEach((item,index)=>{
                                this.restaurantgy1.push({value:item.user_name,staff_id:item.user_id,saler:item.saler})
                            })
                        }
                        if (this.gylForm.yewu_name !== '') {
                            this.restaurantgy2 = []
                            res.data.data.forEach((items, index) => {
                                if (items.user_name === this.gylForm.yewu_name) {
                                    console.log('deng')
                                    items.saler.forEach((item, index) => {
                                        this.restaurantgy2.push({value: item.user_name, store_id: item.user_id, contact: item.contact, office_phone: item.office_phone, address: item.address, user_area: item.user_area})
                                    })
                                }
                            })
                        }
                    })
                },
                //选择业务员
                querySearchgy1(queryString, cb) {
                    var restaurantgy1 = this.restaurantgy1;
                    var results = queryString ? restaurantgy1.filter(this.createFiltergy1(queryString)) : restaurantgy1;
                    // 调用 callback 返回建议列表的数据
                    cb(results);
                },
                createFiltergy1(queryString) {
                    return (restaurant) => {
                        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                    };
                },
                handleSelectgy1(item) {
                    this.gylForm.yewu_id = item.staff_id
                    this.gylForm.jingxiao = ''
                    this.gylForm.jingxiao_id = ''
                    this.restaurantgy2=[]
                    if (item.saler.length!==0) {
                        item.saler.forEach((item, index) => {
                            this.restaurantgy2.push({value: item.user_name,store_id:item.user_id,contact:item.contact,office_phone:item.office_phone,address: item.address, user_area: item.user_area})
                        })
                    } else {
                        this.restaurantgy2 = []
                    }
                },


                querySearchgy2(queryString, cb) {
                    var restaurantgy2 = this.restaurantgy2;
                    var results = queryString ? restaurantgy2.filter(this.createFiltergy2(queryString)) : restaurantgy2;
                    // 调用 callback 返回建议列表的数据
                    cb(results);
                },
                createFiltergy2(queryString) {
                    return (restaurant) => {
                        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                    };
                },
                handleSelectgy2(item) {
                    this.gylForm.jingxiao_id = item.store_id
                    this.gylForm.quyu = item.user_area
                    this.gylForm.mobile = item.office_phone
                    this.gylForm.address = item.address
                    this.gylForm.kehu_name = item.contact
                },
                //添加门店
                addMendian() {
                    this.addMdForm.staff_id = this.staff_id
                        this.showMendian = true
                },
                qrAddMendian() {
                    this.$http.post(this.$reqUrl + 'user.php?act=store_add', qs.stringify(this.addMdForm)).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.msg)
                            this.getMendianList()
                            this.showMendian = false
                            this.addMdForm = {
                                store_name: '',
                                store_sn: '',
                                store_district: '',
                                store_system: '',
                                account_company: '',
                                storage: '',
                                staff_id: '',
                            }
                        } else if (res.data.error === 1) {
                            this.$message.error(res.data.msg)
                        }
                    })
                },
                //添加业务员
                addStaff() {
                    // console.log(this.gylForm.yewu_name);
                    if (this.gylForm.yewu_name === '') {
                        this.$message.error('请选择业务员')
                    } else {
                        this.showYewu = true
                    }
                },
                //上传图片
                upImgs1(item) {
                    let self = this;
                    var file = item.file
                    var reader = new FileReader()
                    reader.readAsDataURL(file)
                    reader.onload = function(e) {
                        self.baseImg1 = this.result
                        self.Form.formData1.push(self.baseImg1);
                    }
                    // console.log(self.Form.formData1);
                },
                handleExceed1() {
                    this.$error.message('只能选择三张图片')
                },
                beforeAvatarUpload1(file) {
                    if (!/image\/\w+/.test(file.type)) {
                        this.$message.error('只能上传图片')
                        return false
                    }
                },
                //移除凭证钩子
                removepz1(val) {
                    Array.prototype.remove = function (val) {
                        var index = this.indexOf(val);
                        if (index > -1) {
                            this.splice(index, 1);
                        }
                    };
                    var file = val.raw
                    var reader = new FileReader()
                    reader.readAsDataURL(file)
                    let self = this;
                    reader.onload = function(e) {
                        self.Form.formData1.remove(this.result);
                        // console.log(self.formData1)
                    }
                },
                clearUploadedImage () {
                    this.$refs.upload.clearFiles();
                    this.Form.formData1 = []
                },
                handlePreview(file) {
                    // console.log(file);
                },
                passOrder() {
                    if (this.goodsList.length === 0) {
                        this.$message.error('请添加商品')
                        return false
                    } else if (this.Form.user_name === '' || this.Form.store_name === '') {
                        this.$message.error('请完善信息')
                        return false
                    } else if (this.goodsList.length !== 0) {
                        let carts = []
                        this.goodsList.forEach(item => {
                            carts.push({model: item.goods_attr, goods_number: item.goods_number, goods_price: item.goods_price, goods_id: item.goods_id, goods_attr_id: item.goods_attr_id})
                        })
                            let data = {
                                contract_number: this.Form.contart_number,
                                add_time: Date.parse(new Date(this.Form.addtime.getTime())).toString().slice(0, 10),
                                staff_sn: this.staff_sn,
                                staff_name: this.Form.user_name,
                                user_name: this.Form.jingxiao,
                                user_id: this.Form.jingxiao_id,
                                order_store: this.Form.store_name,
                                postscript: this.Form.beizhu,
                                consignee: this.Form.kehu_name,
                                mobile: this.Form.mobile,
                                address: this.Form.address,
                                order_images: this.Form.formData1,
                                carts: carts,
                            }
                        this.$http.post(this.$reqUrl + 'supply.php?step=pc_store_done&session_id=' + localStorage.getItem('shouhou_session_id'), qs.stringify(data), {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                            }
                        })
                            .then(res => {
                                if (res.data.error === 1) {
                                    this.$message.error(res.data.msg)
                                } else if (res.data.error === 0) {
                                    this.$notify.success({
                                        title: '操作成功',
                                        message: '已成功下单'
                                    });
                                    if (this.Form.yuyue_time !== '') {
                                        this.$http.get(this.$reqUrl + `user.php?act=order_list&searchkey=${this.Form.contart_number}&searchType=contract_number&session_id=${localStorage.getItem('shouhou_session_id')}`)
                                            .then(res => {
                                                let yyData = {
                                                    order_sn: res.data.data[0].order_sn,
                                                    yuyue_time: Date.parse(this.Form.yuyue_time.toLocaleDateString()).toString().slice(0, 10),
                                                    order_id: res.data.data[0].order_id,
                                                    status: '8',
                                                }
                                                this.$http.post(this.$reqUrl + `bind_order.php?act=post_orders_yuyue&session_id = ${localStorage.getItem('shouhou_session_id')}`, qs.stringify(yyData)).then(res => {
                                                    if (res.data.error === 0) {
                                                        this.$message.success('预约成功')
                                                        this.Form = {
                                                            contart_number: '',
                                                            yuyue_time: '',
                                                            addtime: new Date(),
                                                            kehu_name: '',
                                                            mobile: '',
                                                            address: '',
                                                            beizhu: '',
                                                            goods: [],
                                                            formData1: [],
                                                            store_name: '',
                                                            jingxiao: '',
                                                            jingxiao_id: '',
                                                            name: '',
                                                        }
                                                        this.clearUploadedImage()
                                                    }
                                                })
                                            })
                                    } else {
                                        this.Form = {
                                            contart_number: '',
                                            yuyue_time: '',
                                            addtime: new Date(),
                                            kehu_name: '',
                                            mobile: '',
                                            address: '',
                                            beizhu: '',
                                            goods: [],
                                            formData1: [],
                                            store_name: '',
                                            jingxiao: '',
                                            jingxiao_id: '',
                                            name: '',
                                        }
                                        this.clearUploadedImage()
                                    }
                                    this.goodsList = []
                                } else {
                                    this.$notify.error({
                                        title: '操作失败',
                                        message: '下单失败'
                                    });
                                }
                            })
                    }
                },
                passOrder1() {
                    if (this.goodsList.length === 0) {
                        this.$message.error('请添加商品')
                        return false
                    } else if (this.gylForm.yewu_name === '' || this.gylForm.jingxiao === '') {
                        this.$message.error('请完善信息')
                        return false
                    } else if (this.goodsList.length !== 0) {
                        let carts = []
                        this.goodsList.forEach(item => {
                            carts.push({model: item.goods_attr, goods_number: item.goods_number, goods_price: item.goods_price, goods_id: item.goods_id, goods_attr_id: item.goods_attr_id})
                        })
                        var data = {
                            contract_number: this.gylForm.contart_number,
                            'pc_carts': carts,
                            'order_images': this.Form.formData1,
                            'postscript': this.gylForm.beizhu,
                            add_time: Date.parse(new Date(this.Form.addtime.getTime())).toString().slice(0, 10),
                            'admin_user_name': this.gylForm.yewu_name,
                            'admin_user_id': this.gylForm.yewu_id,
                            'user_name': this.gylForm.jingxiao,
                            'user_id': this.gylForm.jingxiao_id,
                            consignee: this.gylForm.kehu_name,
                            mobile: this.gylForm.mobile,
                            address: this.gylForm.address,
                            inv_payee: this.Form.inv_payee,
                            order_admin_name: this.gylForm.zhidanren,
                            store_storage: this.gylForm.cangku,
                            store_district: this.gylForm.quyu
                        }
                        var datas = qs.stringify(data)
                        // console.log(data)
                        this.$http.post(this.$reqUrl + 'supply.php?step=post_done&session_id=' + localStorage.getItem('shouhou_session_id'), datas, {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                            }
                        })
                            .then(res => {
                                if (res.data.error==1) {
                                    this.$message.error(res.data.msg)
                                } else if (res.data.error === 0) {
                                    this.$notify.success({
                                        title: '操作成功',
                                        message: '已成功下单'
                                    });
                                    this.Form = {
                                        contart_number: '',
                                        yuyue_time: '',
                                        addtime: new Date(),
                                        kehu_name: '',
                                        mobile: '',
                                        address: '',
                                        beizhu: '',
                                        goods: [],
                                        formData1: [],
                                    }
                                    this.gylForm = {
                                        yewu_name: '',
                                            yewu_id: '',
                                            jingxiao: '',
                                            jingxiao_id: '',
                                            inv_payee: '',
                                            quyu: '',
                                            cangku: '正价仓',
                                            zhidanren: localStorage.getItem('user_name'),
                                    }
                                    this.clearUploadedImage()
                                    this.goodsList = []
                                } else {
                                    this.$notify.error({
                                        title: '操作失败',
                                        message: '下单失败'
                                    });
                                }
                            })
                            .catch(res => {
                                // console.log(res)
                            })
                    }
                },
                passOrder2() {
                    // console.log(this.gylForm.inv_type);
                    // console.log(typeof this.gylForm.inv_type);
                    if (this.goodsList.length === 0) {
                        this.$message.error('请添加商品')
                        return false
                    } else if (this.gylForm.yewu_name === '' || this.gylForm.jingxiao === '') {
                        this.$message.error('请完善信息')
                        return false
                    } else if (this.goodsList.length !== 0) {
                        let carts = []
                        this.goodsList.forEach(item => {
                            carts.push({model: item.goods_attr, goods_number: item.goods_number, goods_price: item.goods_price, goods_id: item.goods_id, goods_attr_id: item.goods_attr_id})
                        })
                        let inv_type = this.inv_type
                        if (this.gylForm.inv_type === '') {
                            inv_type = '送货到客户'
                        }
                        var data = {
                            single_number: this.gylForm.vip_number,
                            inv_type: inv_type,
                            inv_payee: this.gylForm.inv_payee,
                            contract_number: this.gylForm.contart_number,
                            'pc_carts': carts,
                            'order_images': this.Form.formData1,
                            'postscript': this.gylForm.beizhu,
                            add_time: Date.parse(new Date(this.Form.addtime.getTime())).toString().slice(0, 10),
                            'admin_user_name': this.gylForm.yewu_name,
                            'admin_user_id': this.gylForm.yewu_id,
                            'user_name': this.gylForm.jingxiao,
                            'user_id': this.gylForm.jingxiao_id,
                            consignee: this.gylForm.kehu_name,
                            mobile: this.gylForm.mobile,
                            address: this.gylForm.address,
                            order_admin_name: this.gylForm.zhidanren,
                            store_storage: this.gylForm.cangku,
                            store_district: this.gylForm.quyu
                        }
                        var datas = qs.stringify(data)
                        console.log(data);
                        this.$http.post(this.$reqUrl + 'supply.php?step=post_done&post_type=pc&session_id=' + localStorage.getItem('shouhou_session_id'), datas, {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                            }
                        })
                            .then(res => {
                                if (res.data.error == 1) {
                                    this.$message.error(res.data.msg)
                                } else if (res.data.error === 0) {
                                    this.$notify.success({
                                        title: '操作成功',
                                        message: '已成功下单'
                                    });
                                    // window.open(host + '/flow.php?step=order_pay&id=' + res.data.order_id);
                                    this.Form = {
                                        contart_number: '',
                                        yuyue_time: '',
                                        addtime: new Date(),
                                        kehu_name: '',
                                        mobile: '',
                                        address: '',
                                        beizhu: '',
                                        goods: [],
                                        formData1: [],
                                    }
                                    this.gylForm = {
                                        vip_number: '',
                                        inv_type: '',
                                        inv_payee: '',
                                        yewu_name: '',
                                        yewu_id: '',
                                        jingxiao: '',
                                        jingxiao_id: '',
                                        quyu: '',
                                        cangku: '正价仓',
                                        zhidanren: localStorage.getItem('user_name'),
                                    }
                                    this.clearUploadedImage()
                                    this.goodsList = []
                                } else {
                                    this.$notify.error({
                                        title: '操作失败',
                                        message: '下单失败'
                                    });
                                }
                            })
                            .catch(res => {
                                // console.log(res)
                            })
                    }
                }
            }
        }
</script>
<style>
    /*.el-scrollbar{*/
        /*z-index: 2500;*/
    /*}*/
    /*.el-popper[x-placement^=bottom]{*/
        /*z-index: 9000;*/
    /*}*/
</style>
<style lang="less" scoped>
.mendian{
    text-align: center;
    /*display: flex;*/

}
    .mendian .form{
        display: inline-block;
        width: 65%;
        margin-top: 20px;
        box-sizing: border-box;
        padding: 30px 30px;
        margin-right: 20px;
        background-color: #ebebeb;

    }
    .mendian .add-btn{
        border: 0;
        background-color: #2e86ff;
        color: white;
        padding: 10px 15px;
        border-radius: 3px;
        margin-top: 10px;
        cursor: pointer;
    }
    .select-tarbar{
        display: inline-block;
        padding: 10px 30px;
        margin: 0 50px;
        border: 1px solid #333;
        color: #333;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/router/Mendian.vue